module.exports = __webpack_public_path__ + "img/icon_xmyp.032183db.png";